import {getMerkmal} from "../../misc/widget-functions"
import React from "react"
import {Box, Typography} from "@mui/material"

const ValueDisplayTableWidget = ({widget, getDataFromPointer}) => {
    const pointer = getMerkmal(widget)?.pointer
    const value = getDataFromPointer(pointer)

    return (
        <Box pb={1} display="flex" justifyContent="space-between"
             borderBottom="1px solid #e1e4ee">
            <Typography fontWeight={600}>{widget?.text ?? ""}</Typography>
            <Typography fontWeight={600} color="#1735d0">{value}</Typography>
        </Box>
    )
}

export default ValueDisplayTableWidget